module.exports = __webpack_public_path__ + "img/tpc-web-5.a107ee70.jpg";